export default __webpack_public_path__ + "static/media/cooking.c8c65bd9.svg";